import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
// component, hooks
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import AccordionMain from "../../../../../../common/components/accordion/AccordionMain";
import AccordionDetailChildren from "./AccordionDetailChildren";
// store
import { StoreContext } from "../../../../../../store/StoreProvider";
// config,utils
import urls from "../../../../../../api/project/ApiUrls";
import fireAuth from "../../../../../../api/firebase/auth/utils";

// style

const LinkCountFilter = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { filter } = sna;
  // local state
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);

  return (
    <Box mb={1}>
      <AccordionMain
        accordionProps={{}}
        darkMode
        summaryChildren={{
          text: intl.formatMessage({
            id: "sna.sidebar.filtertool.link.count",
            defaultMessage: "鏈結數篩選",
          }),
          // tail: <AccordionSummaryTail />,
        }}
        detailsChildren={<AccordionDetailChildren />}
        detailsProps={{}}
      />
    </Box>
  );
};

LinkCountFilter.propTypes = {};

LinkCountFilter.defaultProps = {};

export default LinkCountFilter;
